const locale = require('./assignAccount.i18n.json');

/*@ngInject*/
const AssignAccountModalController = function ($rootScope, $scope, $timeout, $state, accountMediator,uiPerformanceLoggerConstant,
			advancedFilterMediator, advancedFilterModel, advancedFilterType, authorizationConstants, coreConstant, currentUserModel,
			loadingBarHandler, modalUtil, landingConstant, submission, submissionConstant, submissionGridConstant) {

    let timeoutList = [];

    $scope.i18n = locale;

    $scope.viewModel = {
        existingAccount: undefined,
        filterModel: undefined,
        hasAssignAccountPermission: false,
        selectedAccount: undefined,
        submission: submission,
        accounts: null,
        requestParams: {
            key: 'name',
            sortBy: 'desc'
        },
        advancedFilterType: advancedFilterType.ACCOUNT_GRID
    };

    function init() {
        loadFilter();
        $scope.viewModel.hasAssignAccountPermission = currentUserModel.hasAuthorization(authorizationConstants.ASSIGN_ACCOUNT);

        accountMediator.getAccountById(submission.accountId).then(function (account) {
            $scope.viewModel.existingAccount = account;
        });
    }

    function loadFilter() {
        let filters,
            filter;
        advancedFilterMediator.getFilters().then(function (returnedFilters) {
            filters = _.filter(returnedFilters, {'type': 2, 'temporary': false});
            filter = _.first(filters);
            if (filter) {
                advancedFilterMediator.getFilterTemplates(filter.filterTemplateId).then(function (filterTemplate) {
                    advancedFilterModel.buildFilter($scope.viewModel.advancedFilterType, filterTemplate, filter, true);
                    $scope.viewModel.filterModel = advancedFilterModel.getAdvancedFilterModel($scope.viewModel.advancedFilterType);
                });
            }
        });
    }

    function handleFilterSave(event, filter) {
        $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.ASSIGN_ACCOUNT_SEARCH, $scope.viewModel.submission.id);
        advancedFilterModel.getAdvancedFilterModel($scope.viewModel.advancedFilterType).filter = filter;
        $scope.viewModel.accounts = null;
        $scope.viewModel.selectedAccountId = null;
        $scope.viewModel.selectedAccountNumber = null;

        let onFailure = () => {
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.ASSIGN_ACCOUNT_SEARCH, coreConstant.uiPeformanceLogger.FAIL);
        };

        accountMediator.getAccountsByFilterUri(filter.uri, $scope.viewModel.requestParams).then(function (accountsMap) {
            $scope.viewModel.accounts = accountsMap.accountSummaries;
            // Ensure accounts are updated before we update the grid
            timeoutList.push($timeout(function () {
                $scope.$broadcast(submissionGridConstant.event.RESET_GRID_LIST);
            }, 500));
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.ASSIGN_ACCOUNT_SEARCH, coreConstant.uiPeformanceLogger.SUCCESS);
        }, onFailure);
    }

    $scope.$on(coreConstant.event.FILTER_SAVED, handleFilterSave);

    $scope.$on(submissionConstant.event.UPDATE_ACCOUNT_GRID, function (event, params) {
        $scope.viewModel.requestParams = params;
        handleFilterSave(null, advancedFilterModel.getAdvancedFilterModel($scope.viewModel.advancedFilterType).filter);
    }.bind(this));

    $scope.isAssignExistingAccountEnabled = function () {
        return (!_.isNil($scope.viewModel.selectedAccountId) || !_.isNil($scope.viewModel.selectedAccountNumber)) &&
            $scope.viewModel.selectedAccountId !== submission.accountId &&
            $scope.viewModel.hasAssignAccountPermission;
    };

    $scope.assignExistingAccount = function () {
        let translations = this.i18n.assignConfirmationModal;

        if ($scope.isAssignExistingAccountEnabled()) {

            if ($scope.viewModel.existingAccount.validated) {
                translations = this.i18n.assignExistingConfirmationModal;
            }

            let onFailure = () => {
                $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.ASSIGN_ACCOUNT_EXISTING, coreConstant.uiPeformanceLogger.FAIL)
            };

            modalUtil.showGenericConfirm(translations).then(function () {
                $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.ASSIGN_ACCOUNT_EXISTING, submission.id);
                loadingBarHandler.showLoadingBar(translations.loadingBar);
                accountMediator.assignAccount(submission.id, $scope.viewModel.selectedAccountId, $scope.viewModel.selectedAccountNumber)
                    .then((submission) => {
                        $state.go('submission.accountSubmissionsGrid', {
                            submissionId: submission.id,
                            accountId: submission.accountId
                        }, {
                            reload: true
                        });
                        $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.ASSIGN_ACCOUNT_EXISTING, coreConstant.uiPeformanceLogger.SUCCESS);
                    },onFailure)
                    .finally(() => {
                        loadingBarHandler.hideLoadingBar();
                        $scope.$close();
                    });
            });
        }
    };

    $scope.isValidateAccountEnabled = function () {
        let accountExists = !_.isNil($scope.viewModel.existingAccount);

        return $scope.viewModel.hasAssignAccountPermission &&
            accountExists && !$scope.viewModel.existingAccount.validated;
    };

    $scope.validateAccount = function () {
        let translations = this.i18n.validateConfirmationModal;

        if ($scope.isValidateAccountEnabled()) {

            let onFailure = () => {
                $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.ASSIGN_ACCOUNT_CREATE_NEW, coreConstant.uiPeformanceLogger.FAIL)
            };

            modalUtil.showGenericConfirm(translations).then(function () {
                loadingBarHandler.showLoadingBar(translations.loadingBar);
                accountMediator.validateAccount($scope.viewModel.existingAccount.id)
                    .then((validAccount) => {
                        $state.go('submission.accountSubmissionsGrid', {
                            submissionId: $scope.viewModel.submission.id,
                            accountId: validAccount.id
                        }, {
                            reload: true
                        });
                        $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.ASSIGN_ACCOUNT_CREATE_NEW, coreConstant.uiPeformanceLogger.SUCCESS);
                    },onFailure)
                    .finally(() => {
                        loadingBarHandler.hideLoadingBar();
                        $scope.$close();
                    });
            });
        }
    };

    $scope.isCreateNewAccountEnabled = function () {
        let accountExists = !_.isNil($scope.viewModel.existingAccount);
        return $scope.viewModel.hasAssignAccountPermission &&
            accountExists && $scope.viewModel.existingAccount.validated;
    };

    $scope.createNewAccount = function () {
        let translations = this.i18n.createConfirmationModal;

        if ($scope.isCreateNewAccountEnabled()) {

            let onFailure = () => {
                $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.ASSIGN_ACCOUNT_CREATE_NEW, coreConstant.uiPeformanceLogger.FAIL);
            };

            modalUtil.showGenericConfirm(translations).then(function () {
                $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.ASSIGN_ACCOUNT_CREATE_NEW, $scope.viewModel.submission.id);
                loadingBarHandler.showLoadingBar(translations.loadingBar);

                accountMediator.createAccount($scope.viewModel.submission.id)
                    .then((newAccount) => {
                        $state.go('submission.accountSubmissionsGrid', {
                            submissionId: $scope.viewModel.submission.id,
                            accountId: newAccount.id
                        }, {
                            reload: true
                        });
                        $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.ASSIGN_ACCOUNT_CREATE_NEW, coreConstant.uiPeformanceLogger.SUCCESS);
                    }, onFailure)
                    .finally(() => {
                        loadingBarHandler.hideLoadingBar();
                        $scope.$close();
                    });
            });
        }
    };

    $scope.$on(submissionGridConstant.event.OPEN_SUBMISSION_DETAIL_DRAWER, function (event, selectedAccountId, selectedAccountNumber) {
        $scope.viewModel.selectedAccountId = selectedAccountId;
        $scope.viewModel.selectedAccountNumber = selectedAccountNumber;
    });

    $scope.$on('$destroy', function () {
        _.each(timeoutList, function (item) {
            $timeout.cancel(item);
        });
    });

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);

    init();
};

angular.module('gw-um-submission')
    .controller('assignAccountModalController', AssignAccountModalController);
